module.exports = __webpack_public_path__ + "img/jisho_logo_baksida_30.eba8b1fa.png";